import src from "IMAGE";
export default { src, width: 24, height: 32, blurWidth: 0, blurHeight: 0};
